import { useSyncExternalStore } from "react";

/**
 * Subscribe to a CSS media query. Returns `false` where `matchMedia` is unavailable (jsdom, SSR) — callers must treat
 * the query's content as optional, never as the only path to a capability.
 *
 * Used to MOUNT width-dependent chrome (the drill-down preview panel) only when there is room, rather than hiding it
 * with CSS: a `display:none` panel would still be in the accessibility tree and double every heading on the page.
 */
export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      const mql = typeof window.matchMedia === "function" ? window.matchMedia(query) : null;
      mql?.addEventListener("change", onChange);
      return () => mql?.removeEventListener("change", onChange);
    },
    () => (typeof window.matchMedia === "function" ? window.matchMedia(query).matches : false),
    () => false,
  );
}
